import { useEffect, useRef, useState } from 'react';
import { LoadingSpinner } from '@vfit/shared/atoms';
import { IIframeDetail } from './iframeDetail.models';
import { Container, Title } from './iframeDetail.style';

const IframeFullPage = ({ title, url, options, minHeight }: IIframeDetail) => {
  const [isLoading, setIsLoading] = useState(true);
  const [iframeHeight, setIframeHeight] = useState('0px');
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'setHeight' && event.data?.height && iframeRef.current) {
        setIframeHeight(`${event.data.height}px`);
        // iframeRef.current.style.height = `${event.data.height}px`;
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <Container>
      <div className="iframe-holder">
        {title && (
          <Title textAlign={options?.textAlign} dangerouslySetInnerHTML={{ __html: title }} />
        )}
        {isLoading && <LoadingSpinner />}
        <iframe
          src={url}
          ref={iframeRef}
          title={title || ''}
          onLoad={() => setIsLoading(false)}
          frameBorder={0}
          style={{
            width: '100%',
            overflow: 'hidden',
            height: iframeHeight,
          }}
          scrolling="no"
        />
      </div>
    </Container>
  );
};

export default IframeFullPage;

